<template>
  <div class="d-flex">
    <!-- Sinal Option (exato, maior, menor) -->
    <v-select
      v-model="select"
      :items="items"
      :label="label"
      @change="setSinal"
      prepend-icon="mdi-currency-usd"
      item-text="text"
      item-value="option"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
    <!-- Sinal Valor -->
    <v-text-field
      v-model="valor"
      class="ml-2"
      label="Outlined"
      :placeholder="$t('value')"
      solo-inverted
      dense
      hide-details
      @change="setSinal"
      :prefix="$t('labelCurrency')"
      type="number"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-sinal",
  data: () => ({
    select: null,
    valor: null,
  }),
  computed: {
    items() {
      if (
        this.$route.name === "ListPlayersOnline" ||
        this.$route.name === "CollaboratorListPlayersOnline"
      ) {
        return [
          { text: this.$t("exactBalance"), option: "exatamente" },
          { text: this.$t("balanceGreaterThan"), option: "maior" },
          { text: this.$t("balanceLessThan"), option: "menor" },
        ];
      } else {
        return [
          { text: this.$t("exactValue"), option: "exatamente" },
          { text: this.$t("valueGreaterThan"), option: "maior" },
          { text: this.$t("valueLessThan"), option: "menor" },
        ];
      }
    },
    label() {
      if (
        this.$route.name === "ListPlayersOnline" ||
        this.$route.name === "CollaboratorListPlayersOnline"
      ) {
        return this.$t("byBalance");
      } else {
        return this.$t("byValue");
      }
    },
  },
  mounted() {
    // Recupera o último valor informado pelo o usuário
    // e deixa o select selecionado com o mesmo.
    var option = this.$store.state.filters.sinal.option;
    var select = this.items.filter((element) => element.option == option);
    this.select = select[0];
  },
  methods: {
    setSinal() {
      var option = this.select;
      var valor = this.valor;
      // Só enviar para o vuex se os dois estiverem preenchidos:
      if (option != null && valor != null) {
        this.$store.commit("setSinal", { option, valor });
      }
    },
  },
};
</script>
